'use client';

import { isServer, type QueryClient } from '@tanstack/react-query';

import { makeQueryClient } from './query-client';

let browserQueryClient: QueryClient | undefined;
export function getQueryClient() {
  // Never share personalized data across server requests.
  if (isServer) return makeQueryClient();
  browserQueryClient ??= makeQueryClient();
  return browserQueryClient;
}
